/**
 * @des 引入vant 组件
 */
import Vue from 'vue';
import 'vant/lib/index.css';
import {
  Button,
  Swipe,
  SwipeItem,
  List,
  Cell,
  Dialog,
  PullRefresh,
  NoticeBar,
  Toast,
  Icon,
  Tabs,
  Tab,
  Empty,
} from 'vant';

Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Cell);
Vue.use(Dialog);
Vue.use(PullRefresh);
Vue.use(NoticeBar);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Empty);
